<div>
  <p>{{ description | loadTemplateData$ | async }}</p>

  @for (collection of collections; track collection) {
    <button mat-raised-button data-e2e="collections-block-navigate-collection" (click)="navigate(collection)" class="inverted">
      <img [src]="collection.image" alt="">
      <div>
        <h3>{{ collection.title }}</h3>
        <p>{{ collection.description }}</p>
      </div>
    </button>
  }
</div>
